module.exports = __webpack_public_path__ + "media/images/icons/plus-circle-89e0f7459f170a02c6a6dba7a1709400.svg";